<template>
    <div class="popup-zlatnik" :class="{popupactive: activePopup}">
        <div class="popup-inner">
            <i @click="closePopup"  class="popup-close"></i>
            <h2 class="popup-title">
                Napomena
            </h2>
            <h6 class="popup-text">
                Prije zaključavanja odaberi jedan od ponuđenih odgovora
            </h6>
            <a @click.prevent="closePopup" class="button-1 red"><span>Odaberi odgovor</span></a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'popup-answer',
    props: ['activePopup'],
    methods: {
        closePopup () {
            this.$emit('closePopup')
        }
    }
}
</script>

<style lang="scss" scoped>
    .button-1 {
        cursor: pointer;
        padding: 11px 17px;
        span {
            padding: 0 30px;
        }
    }
</style>
